<template>
  <div class="container-fluid">
    <div class="row mt-3">
      <div
        v-if="
          FastpaymentData.length != 0 &&
          $session.get('AccessMenu').filter((x) => x.id == 32)[0].isMenu
        "
        class="col-12 p-2"
      >
        <net-pa-card v-if="$store.state.renderComponent">
          <template v-slot:header>
            <h6><i class="fas fa-credit-card ml-2"></i>پرداخت سریع</h6>
          </template>
          <template v-slot:content>
            <div class="row">
              <div class="col-md-4 col-12">
                <div
                  class="border bnp-rounded p-0 text-center bg-dark text-light"
                >
                  <div class="row">
                    <div class="col-12 text-center p-1 pt-2">
                      <h6 class="font-weight-bold text-light">
                        <i
                          class="fas fa-circle font-weight-bold text-warning ml-2"
                        ></i
                        >کل مبلغ سررسید شده
                      </h6>
                    </div>
                    <div class="col-12" style="min-height: 24vh">
                      <div class="row">
                        <div class="col-12 text-center mt-2 mx-2">
                          <span class="text-light">مبلغ سررسید شده بابت </span>
                          <span class="text-warning" style="font-size: 15px">{{
                            TotalFastPay.VamCoutFastPay
                          }}</span>
                          <span class="text-light">
                            {{ $GetIsAnbohSaz() == "false" ? "وام" : "پروژه" }}
                          </span>
                        </div>
                        <div class="col-12 text-center mt-1 mx-2">
                          <span class="text-light">مبلغ جریمه </span>
                          <span class="text-danger" style="font-size: 15px">{{
                            $Comma3ragham(TotalFastPay.SumJarmieFastPay)
                          }}</span>
                        </div>
                        <div class="col-12 text-center mt-1">
                          <span class="text-light"> مبلغ قابل پرداخت: </span>
                        </div>
                        <div class="col-3"></div>
                        <div class="col-6 mt-2 text-center">
                          <label
                            style="font-size: 20px"
                            class="border-bottom boroder-light"
                            >{{
                              $Comma3ragham(TotalFastPay.SumMabFastPay + "")
                            }}</label
                          >
                        </div>
                        <div class="col-3"></div>
                        <div class="col-12 text-center tex-light my-1">
                          <span class="text-light">{{
                            $Mab2persianRial(TotalFastPay.SumMabFastPay + "")
                          }}</span>
                        </div>
                        <div class="col-3 mt-1"></div>
                        <div class="col-6 mt-1">
                          <button
                            class="bnp-rounded text-light btn w-100 mb-1"
                            :disabled="TotalFastPay.SumMabFastPay == 0"
                            @click="Pay"
                            style="background: #435ebe !important"
                          >
                            &nbsp; پرداخت سریع &nbsp;
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="col-md-8 mt-md-0 mt-2 col-12"
                style="max-height: 220px; overflow-y: scroll"
              >
                <div class="row">
                  <div
                    v-for="(item, index) in FastpaymentData"
                    :key="index"
                    class="col-12 border-right border-success Netpa-Shadow-2 bg-white p-1 mt-2 px-4"
                    style="border-right: solid 2px !important"
                  >
                    <div class="row">
                      <div class="col-6 mt-md-0 mt-2 text-center col-md-2">
                        <span
                          v-if="$GetIsAnbohSaz() == 'false'"
                          class="text-secondary"
                          >نام پروژه:
                        </span>
                        <span v-else class="text-secondary">نام تسهیلات: </span>
                        <br />
                        <small class="no-wrap">{{ item.desNoe }}</small>
                      </div>
                      <div
                        class="col-6 mt-md-0 mt-2 text-center col-md-2"
                        dir="rtl"
                      >
                        <span
                          v-if="$GetIsAnbohSaz() == 'false'"
                          class="text-secondary"
                          >شماره قرارداد</span
                        >
                        <span v-else class="text-secondary">شماره تسهیلات</span>
                        <br />
                        <small class="no-wrap" dir="rtl">{{
                          item.vCode
                        }}</small>
                      </div>
                      <div
                        class="col-6 mt-md-0 mt-2 text-center col-md-2"
                        dir="rtl"
                      >
                        <span class="text-secondary">تاریخ قسط</span><br />
                        <small class="no-wrap" dir="rtl">{{
                          item.minTarGhestBedehkar
                        }}</small>
                      </div>
                      <div
                        class="col-6 mt-md-0 mt-2 text-center col-md-2"
                        dir="rtl"
                      >
                        <span class="text-secondary">مبلغ قابل پرداخت</span
                        ><br />
                        <small dir="rtl">{{
                          $Comma3ragham(item.mablghPardakht + "")
                        }}</small>
                      </div>
                      <div
                        class="col-6 mt-md-0 mt-2 text-center col-md-2"
                        dir="rtl"
                      >
                        <span class="text-secondary">مبلغ جریمه</span><br />
                        <span class="text-danger" dir="rtl">{{
                          item.wwwjarime == null
                            ? 0
                            : $Comma3ragham(item.wwwjarime + "")
                        }}</span>
                      </div>
                      <div
                        class="col-12 mt-md-0 mt-2 mb-2 text-center col-md-1"
                        dir="rtl"
                      >
                        <span class="">
                          <div class="custom-control custom-switch">
                            <input
                              type="checkbox"
                              class="custom-control-input InputText"
                              :checked="FastpaymentData[index].Active"
                              v-model="FastpaymentData[index].Active"
                              :id="FastpaymentData[index].vCode + 'active'"
                            />
                            <label
                              class="custom-control-label mt-2 Pointer"
                              :for="FastpaymentData[index].vCode + 'active'"
                              >انتخاب</label
                            >
                          </div>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </net-pa-card>
      </div>

      <div class="col-12 p-2 col-md-12 col-lg-12" v-if="accessMenuTabloo">
        <net-pa-card style="max-height: 300px; overflow-y: auto">
          <template v-slot:header>
            <div
              class="d-flex h-full justify-content-between align-items-center w-100"
            >
              <h6 class="mb-0">
                <i
                  class="fas fa-bell ml-2 fa-2x animate__animated animate__swing animate__infinite text-warning"
                  style="font-size: 20px"
                ></i
                >تابلو اعلانات
              </h6>
              <button
                class="btn btn-sm text-white"
                @click="toggleReadFilter"
                style="
                  font-size: 12px !important;
                  background: transparent;
                  border: none !important;
                "
              >
                <i class="fas fa-check-double ml-1"></i>خوانده شده
              </button>
            </div>
          </template>
          <template v-slot:content>
            <div v-if="Tabloo == 'loading'" class="row px-3">
              <div class="spinner-border text-primary" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>
            <div v-else class="row px-3">
              <div
                v-for="(item, index) in filteredTabloo"
                :key="index"
                class="col-12 pr-0"
              >
                <div class="row">
                  <div class="col-12 py-1 mx-0">
                    <i class="fas fa-comment-alt ml-2 text-info"></i>
                    <span class="mr-3">{{ item.zamanInsert }} </span>
                    <div
                      class="d-flex justify-content-end align-items-center w-100"
                    >
                      <span
                        v-if="item.txtMatnTabloElanat.length > 60"
                        class="badge float-left Pointer p-1 badge-info font-weight-normal"
                        style="font-size: 10px !important"
                        @click="ShowFullNotif(item)"
                        data-toggle="modal"
                        data-target="#Modal-light"
                        >مشاهده کامل</span
                      >
                      <span v-if="!isItemRead(item)" class="mr-3">
                        <span
                          class="badge float-left Pointer p-2 badge-success font-weight-normal"
                          style="font-size: 10px !important"
                          @click="markAsReadWithConfirm(item)"
                          >خواندم</span
                        >
                      </span>
                    </div>
                    <span
                      class="font-weight-bold d-block"
                      style="font-size: 16px !important ; color: #ff0000e8"
                    >
                      {{ item.subjectTabloElanat }}</span
                    >
                  </div>
                  <div
                    class="col-12 px-1 mt-2 container-fluid"
                    style="max-height: 25vh"
                  >
                    <div class="row">
                      <div
                        class="col-12"
                        style="
                          max-height: 5vh;
                          max-width: 100%;
                          text-overflow: ellipsis !important;
                          font-size: 13px;
                        "
                      >
                        {{ item.txtMatnTabloElanat.substring(0, 180) }}
                        <span v-if="item.txtMatnTabloElanat.length > 180"
                          >...</span
                        >
                      </div>
                      <!-- <div class="col-12 text-left">
                        <span v-if="item.txtMatnTabloElanat.length > 180" class="badge Pointer p-1 badge-success font-weight-normal" style="font-size: 10px !important" @click="ShowFullNotif(item)" data-toggle="modal" data-target="#Modal-light">
                          مشاهده کامل</span
                        >
                      </div> -->
                    </div>
                    <hr />
                  </div>
                </div>
              </div>
              <div class="col-12 text-center p-1"></div>
              <div
                v-if="filteredTablooLength < 1"
                class="alert alert-primary w-100 text-right"
              >
                <p style="font-size: 16px !important">
                  {{
                    showReadOnly
                      ? "اعلان خوانده شده‌ای یافت نشد"
                      : "اعلانی یافت نشد"
                  }}
                </p>
              </div>
            </div>
          </template>
        </net-pa-card>
      </div>

      <!-----------------دسترسی سریع جدید---------------->
      <!--k.hr-->
      <div class="col-12 p-2">
        <net-pa-card>
          <template v-slot:header>
            <h6>
              <i class="fas fa-bolt ml-2" aria-hidden="true"></i>دسترسی سریع
            </h6>
          </template>
          <template v-slot:content>
            <div class="d-flex align-items-center w-100">
              <button
                ref="scrollRightBtn"
                @click="scrollRight"
                class="btn btn-link scroll_btn p-2 scrl-r"
                :style="{ display: isScrollable ? 'block' : 'none' }"
              >
                <i class="fa fa-angle-right fa-2x text-dark"></i>
              </button>

              <div
                id="scrollContainer"
                ref="scrollContainer"
                @scroll="updateScrollability"
                class="d-flex flex-row overflow-auto w-100 p-3"
                style="scrollbar-width: none; -ms-overflow-style: none"
              >
                <div
                  v-for="(item, index) in quickAccessMenuItems"
                  :key="index"
                  class="col-1 mx-4 text-center mx-2"
                  style="min-width: 100px"
                  v-if="item.linkCondition"
                >
                  <!-- col-md-2 col-lg-1 mx-lg-5-->
                  <router-link :to="item.linkTo" class="quickAccessItem">
                    <i :class="item.iconClass"></i>
                    <p class="mb-0">{{ item.text }}</p>
                  </router-link>
                </div>
              </div>

              <button
                ref="scrollLeftBtn"
                @click="scrollLeft"
                class="btn btn-link scroll_btn p-2 scrl-l"
                :style="{ display: isScrollable ? 'block' : 'none' }"
              >
                <i class="fa fa-angle-left fa-2x text-dark"></i>
              </button>
            </div>
          </template>
        </net-pa-card>
      </div>
      <!-----------------دسترسی سریع جدید---------------->

      <!--- دسترسی سریع قدیمی
      <div class="col-12 p-2 col-md-12 p-1 col-lg-6">
        <net-pa-card>
          <template v-slot:header>
            <h6>
              <i class="fas fa-bolt ml-2" aria-hidden="true"></i>دسترسی سریع
            </h6>
          </template>
          <template v-slot:content>
            <div class="row">
              <div class="col-6 py-2">
                <router-link :to="'Accounts'" v-if="accessMenuAccount">
                  <div
                    class="w-100 text-center rounded p-2 bg-dark text-light"
                    style="font-size: 15px"
                  >
                    <i class="fas fa-list p-1 ml-2 text-warning"></i> حساب ها
                  </div>
                </router-link>
              </div>
              <div class="col-6 py-2" v-if="accessMenuLoan">
                <router-link :to="'loan'">
                  <div
                    class="w-100 text-center rounded p-2 bg-dark text-light"
                    style="font-size: 15px"
                  >
                    <i class="fas fa-gift p-1 ml-2 text-warning"></i> تسهیلات
                  </div>
                </router-link>
              </div>
              <div class="col-6 py-2" v-if="accessMenuTurnover">
                <router-link :to="'Turnover'">
                  <div
                    class="w-100 text-center rounded p-2 bg-dark text-light"
                    style="font-size: 15px"
                  >
                    <i class="fas fa-receipt p-1 ml-2 text-warning"></i> صورت
                    حساب
                  </div>
                </router-link>
              </div>
              <div class="col-6 py-2" v-if="accessMenu1">
                <router-link :to="{ name: 'Debtor' }">
                  <div
                    class="w-100 text-center rounded p-2 bg-dark text-light"
                    style="font-size: 15px"
                  >
                    <i class="fas fa-arrow-up p-1 ml-2 text-warning"></i>برداشت
                    از حساب
                  </div>
                </router-link>
              </div>
              <div class="col-6 py-2" v-if="accessMenu2">
                <router-link
                  :to="{
                    name: 'Deposit',
                    params: { IsShowComboHesab: true, IsTashilat: false },
                  }"
                >
                  <div
                    class="w-100 text-center rounded p-2 bg-dark text-light"
                    style="font-size: 15px"
                  >
                    <i class="fas fa-arrow-down ml-2 text-warning"></i>
                    {{
                      $session.get("IsTaavoniEtebar") == true
                        ? "افزایش اعتبار"
                        : "واریز به حساب"
                    }}
                  </div>
                </router-link>
              </div>
              <div class="col-6 py-2" v-if="accessMenu3">
                <router-link
                  :to="{
                    name: 'Deposit',
                    params: { IsShowComboHesab: true, IsTashilat: true },
                  }"
                >
                  <div
                    class="w-100 text-center rounded p-2 bg-dark text-light"
                    style="font-size: 15px"
                  >
                    <i class="fas fa-coins ml-2 text-warning"></i> پرداخت اقساط
                  </div>
                </router-link>
              </div>
              <div class="col-6 py-2" v-if="accessMenu4">
                <router-link :to="{ name: 'DepositGroup' }">
                  <div
                    class="w-100 text-center rounded p-2 bg-dark text-light"
                    style="font-size: 15px"
                  >
                    <i class="fas fa-coins ml-2 text-warning"></i> پرداخت گروهی
                  </div>
                </router-link>
              </div>
            </div>
          </template>
        </net-pa-card>
      </div>-->

      <div
        v-if="
          $session.get('CustCode') == 8002 || $session.get('CustCode') == 898
        "
        class="col-12 p-2 col-md-12 col-lg-12"
      >
        <div class="row">
          <div class="col-md-6 col-12">
            <net-pa-card>
              <template v-slot:header>
                <h6>
                  <i class="fas fa-chart-pie ml-2" aria-hidden="true"></i>نمودار
                  حسابها
                </h6>
              </template>
              <template v-slot:content>
                <div class="col-md-12 col-xl-10 col-xxl-7 col-12 mx-auto">
                  <AccountsChart></AccountsChart>
                </div>
              </template>
            </net-pa-card>
          </div>
          <div class="col-md-6 col-12">
            <net-pa-card>
              <template v-slot:header>
                <h6>
                  <i class="fas fa-chart-line ml-2" aria-hidden="true"></i
                  >نمودار ذخیره صندوق
                </h6>
              </template>
              <template v-slot:content>
                <FundReserveChart></FundReserveChart>
              </template>
            </net-pa-card>
          </div>
        </div>
      </div>
      <div
        v-if="
          $session.get('CustCode') == 8002 || $session.get('CustCode') == 898
        "
        class="col-12 p-2 col-md-12 p-1"
      >
        <div class="col-md-12 col-12">
          <net-pa-card>
            <template v-slot:header>
              <h6>
                <i class="fas fa-chart-bar ml-2" aria-hidden="true"></i>وضعیت
                تسویه سود
              </h6>
            </template>
            <template v-slot:content>
              <ProfitSettlementChart></ProfitSettlementChart>
            </template>
          </net-pa-card>
        </div>
        <div class="col-md-12 col-12">
          <net-pa-card>
            <template v-slot:header>
              <h6>
                <i class="fas fa-chart-bar ml-2" aria-hidden="true"></i>سود های
                تخصیص یافته به اعضا
              </h6>
            </template>
            <template v-slot:content>
              <AllocatedProfitsChart></AllocatedProfitsChart>
            </template>
          </net-pa-card>
        </div>
      </div>

      <!-- درخواست ضمانت -->
      <div
        v-if="ListReqNeedVam && ListReqNeedVam.length != 0"
        class="col-12 mt-1 p-2"
      >
        <net-pa-card
          :Classes="'bg-orange'"
          :IsMinus="false"
          :IdElement="'Zemanat'"
          v-if="$store.state.renderComponent"
        >
          <template v-slot:header>
            <h6 class="text-dark">
              <i class="fas fa-exclamation-triangle ml-2"></i>درخواست ضمانت
            </h6>
          </template>
          <template v-slot:content>
            <div
              class="row boder-bottom pr-2 pl-3"
              v-for="nv in ListReqNeedVam"
              :key="nv.id"
            >
              <div class="col-12 my-2 mx-1 w-100 Netpa-Shadow-2 mt-1 py-3">
                <div class="row">
                  <div class="col-md-3 col-12 text-center">
                    <div class="">
                      <small class="text-dark font-weight-bold mt-2">
                        {{ nv.subjectTabloElanat }}
                      </small>
                    </div>
                    <div class="mt-1">
                      <small
                        class="text-danger font-weight-bold mt-2"
                        style="font-size: 14px"
                      >
                        {{ nv.desNoe }}
                      </small>
                    </div>
                  </div>
                  <div class="col-md-3 col-12 text-center">
                    <span class="text-secondary"> مشخصات</span>
                    <small class="font-weight-bold mt-2">
                      {{ nv.nameFamily }}
                    </small>

                    <div class="mt-1">
                      <span class="text-secondary"> کد ملی</span>
                      <small class="font-weight-bold mt-2">
                        {{ nv.codeMeli }}
                      </small>
                    </div>
                  </div>
                  <div class="col-md-2 col-12 text-center">
                    <span class="text-secondary">
                      مبلغ
                      {{ $GetIsAnbohSaz() == "false" ? "تسهیلات" : "قرارداد" }}
                    </span>
                    <div>
                      <small
                        class="text-danger font-weight-bold mt-2"
                        style="font-size: 16px"
                      >
                        {{ $Comma3ragham(nv.mablagh) }}
                      </small>
                    </div>
                  </div>
                  <div class="col-md-2 col-12 text-center">
                    <span class="text-secondary"> تاریخ درخواست </span>
                    <div class="mt-1">
                      <small class="text-dark font-weight-bold mt-2">
                        {{ nv.zamanInsert }}
                      </small>
                    </div>
                  </div>
                  <div class="col-md-2 col-12 text-center">
                    <!-- <div v-if="$session.get('CustCode')==868" data-toggle="modal" data-target="#Modal-Orange" class="badge badge-success p-1 px-3 py-1 font-weight-normal Pointer w-75" style="border-radius: 4px"><i class="fa fa-check ml-2"></i> تایید ضمانت</div> -->
                    <!-- <div v-else @click="RqNeedVam(nv.id, 1)" class="badge badge-success p-1 px-3 py-1 font-weight-normal Pointer w-75" style="border-radius: 4px"><i class="fa fa-check ml-2"></i> تایید ضمانت</div> -->
                    <div
                      @click="RqNeedVam(nv.id, 1, nv)"
                      class="badge badge-success p-1 px-3 py-1 font-weight-normal Pointer w-75"
                      style="border-radius: 4px"
                    >
                      <i class="fa fa-check ml-2"></i> تایید ضمانت
                    </div>
                    <div
                      @click="RqNeedVam(nv.id, 2, nv)"
                      class="badge badge-danger p-1 px-3 py-1 font-weight-normal Pointer mt-1 w-75"
                    >
                      <i class="fa fa-times ml-2"></i> رد ضمانت
                    </div>
                    <input
                      type="file"
                      @change="changefile"
                      class="d-none required"
                      id="Uploader"
                      accept=".gif,.jpg,.jpeg,.png,.pdf,.zip,.rar"
                    />
                  </div>
                </div>
              </div>
            </div>
          </template>
        </net-pa-card>
      </div>
      <div
        v-if="Moavaghaat && Moavaghaat.length != 0"
        class="col-12 p-2 col-md-12 col-lg-12"
      >
        <net-pa-card
          :Classes="'bg-danger'"
          :IsMinus="true"
          :IdElement="'Moavaghaat'"
          v-if="$store.state.renderComponent"
        >
          <template v-slot:header>
            <h6><i class="fas fa-exclamation-triangle ml-2"></i>اقساط معوقه</h6>
          </template>
          <template v-slot:content>
            <div
              v-for="(item, index) in Moavaghaat"
              :key="index"
              class="my-2 mx-1 w-100 Netpa-Shadow-2 mt-1 py-2"
            >
              <div class="row mt-1">
                <div class="col-12 col-md-3 mt-1 text-center">
                  <span class="text-secondary"> {{ item.desNoe }}</span>
                  <small class="mt-2" dir="rtl"> {{ item.vCode }}</small>
                </div>
                <div class="col-12 col-md-2 text-center">
                  <span class="text-secondary"> تعداد اقساط معوقه </span>
                  <small
                    class="text-danger mt-2"
                    style="font-size: 18px !important"
                  >
                    {{ item.countMoavaghe }}</small
                  >
                </div>
                <div class="col-12 col-md-3 text-center">
                  <span class="text-secondary"> مجموع معوقه </span>
                  <span class="text-danger" style="font-size: 18px !important">
                    {{ item.sumMoavaghe }}</span
                  >
                  <small class="text-secondary mr-1" dir="rtl"
                    >&nbsp; {{ $GetVahedPool() }}
                  </small>
                </div>
                <div class="col-12 col-md-2 text-center">
                  <i class="fas fa-calendar text-secondary ml-2 mt-1"></i
                  ><small class="" dir="rtl">{{ item.zamanInsert }}</small>
                </div>
                <div class="col-12 col-md-2 text-center">
                  <div
                    class="btn btn-outline-dark rounded Pointer"
                    v-if="item.tblSarfaslTypeId == 1"
                  >
                    <router-link
                      :to="{
                        name: 'LoanCardex',
                        params: { TaahodatId: item.id },
                      }"
                      ><i class="fas fa-plus text-dark/ ml-2"></i
                      ><small class="" dir="rtl">کاردکس</small></router-link
                    >
                  </div>
                </div>
              </div>
            </div>
          </template>
        </net-pa-card>
      </div>
      <div class="col-12 p-2 p-1" v-if="accessMenuLoan">
        <net-pa-card v-if="$store.state.renderComponent">
          <template v-slot:header>
            <h6>
              <i class="fas fa-chart-line ml-2"></i
              >{{
                $GetIsAnbohSaz() == "false" ? "وضعیت تسهیلات" : "وضعیت قرارداد"
              }}
            </h6>
          </template>
          <template v-slot:content>
            <div v-if="ChartLoaded == 'loading'" class="row px-3">
              <div class="spinner-border text-primary" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>
            <div v-else class="container-fluid" dir="ltr">
              <apexchart
                v-if="$store.state.renderComponent"
                type="bar"
                height="350"
                :options="chartOptions"
                :series="series"
              ></apexchart>
            </div>
          </template>
        </net-pa-card>
      </div>

      <!-- پرداخت قبوض -->

      <div
        class="col-md-12 w-100"
        v-if="
          $session.get('AccessMenu').filter((x) => x.id == 80).length > 0 &&
          $session.get('AccessMenu').filter((x) => x.id == 80)[0].isMenu
        "
      >
        <div
          class="card Netpa-Shadow bnp-rounded my-3"
          style="border-radius: 15px"
        >
          <div class="card-body text-right pb-5">
            <div class="row">
              <div class="col-12">
                <div class="row my-2 mx-5">
                  <div class="col-12 alert border border-dark text-ceneter">
                    <h6 class="font-weight-bold mt-1 d-inline text-dark">
                      پرداخت قبوض از حساب
                    </h6>
                    <div class="mx-2 d-inline">
                      میتواند قبض های خود را به راحتی از حساب خود پرداخت کنید
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <ghabz @indexSelected="openGhabz"></ghabz>
          </div>
        </div>
      </div>
    </div>
    <modal-custom>
      <template v-slot:ContentModalLight>
        <div class="container-fluid" dir="rtl">
          <div class="row">
            <div class="col-12 text-right border-bottom">
              <span
                class="font-weight-bold mx-2"
                style="font-size: 12 !important"
              >
                <i class="fas fa-comment-alt text-info"></i>
              </span>
              <span
                class="font-weight-bold mx-2"
                style="font-size: 12 !important"
              >
                {{ Notfheader }}
              </span>
              <span
                class="font-weight-bold mx-2"
                style="font-size: 12 !important"
              >
                {{ NotifDate }}
              </span>
            </div>
            <div
              class="col-12 mt-2 text-justify"
              style="line-height: 2 !important; font-size: 14px !important"
              dir="rtl"
            >
              {{ NotifTxt }}
            </div>
          </div>
        </div>
      </template>
      <template v-slot:ContentModalBanafash>
        <div class="row" dir="rtl" style="max-height: 75vh; overflow-y: scroll">
          <div class="col-12 pr-0" v-for="(item, index) in Tabloo" :key="index">
            <div class="col-12 pr-0">
              <div class="col-12 py-1 mx-0 text-right">
                <i class="fas fa-comment-alt ml-2 text-info"></i>
                <span class="font-weight-bold">
                  {{ item.subjectTabloElanat }}</span
                >
                <span class="mr-3 float-left">{{ item.zamanInsert }} </span>
              </div>
              <div class="col-12 px-1 mt-2">
                <div class="row">
                  <div
                    class="col-12 text-justify"
                    style="max-width: 100%"
                    dir="rtl"
                  >
                    {{ item.txtMatnTabloElanat }}
                  </div>
                </div>
                <hr />
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:ContentModalSuccess>
        <debtor></debtor>
      </template>
      <template v-slot:ContentModalOrange>
        <div class="row">
          <div class="col-12">
            <div class="alert alert-secondary text-center">
              برای تایید ضمانت لطفا مدارک خواسته شده را آپلود و سپس نسبت به
              تایید ضمانت اقدام فرمایید
            </div>
          </div>
          <div class="col-md-4 col-12">
            <div
              class="Uploader Pointer text-center py-3"
              @click="OpenUploader(1)"
            >
              <i class="fa fa-file-import fa-5x text-logo mt-3"></i>
              <div class="mt-5">
                فایل <span class="text-warning"> حکم کارگزینی </span> خود را
                بارگذاری کنید
              </div>
              <small class="text-warning">( کلیک کنید )</small>
            </div>
            <input
              type="file"
              class="form-control d-none"
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              id="FileHokm"
              @change="UploadFile($event, 1)"
            />
          </div>
          <div class="col-md-4 col-12">
            <div
              class="Uploader Pointer text-center py-3"
              @click="OpenUploader(2)"
            >
              <i class="fa fa-file-import fa-5x text-logo mt-3"></i>
              <div class="mt-5">
                فایل <span class="text-warning"> فرم ضمــانت </span> خود را
                بارگذاری کنید
              </div>
              <small class="text-warning">( کلیک کنید )</small>
            </div>
            <input
              type="file"
              class="form-control d-none"
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              id="FileZemanat"
              @change="UploadFile($event, 1)"
            />
          </div>
          <div class="col-md-4 col-12">
            <div
              class="Uploader Pointer text-center py-3"
              @click="OpenUploader(3)"
            >
              <i class="fa fa-file-import fa-5x text-logo mt-3"></i>
              <div class="mt-5">
                فایل <span class="text-warning"> قرارداد وام </span> خود را
                بارگذاری کنید
              </div>
              <small class="text-warning">( کلیک کنید )</small>
            </div>
            <input
              type="file"
              class="form-control d-none"
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              id="FileGhrardad"
              @change="UploadFile($event, 1)"
            />
          </div>
        </div>
      </template>
    </modal-custom>
  </div>
</template>
<script>
import ModalCustom from "../Tools/ModalCustom.vue";

import NetPaCard from "../Tools/NetPa/NetPaCard.vue";
import AccountsChart from "./Componenets/AccountsChart.vue";
import FundReserveChart from "./Componenets/FundReserveChart.vue";
import AllocatedProfitsChart from "./Componenets/AllocatedProfitsChart.vue";
import ProfitSettlementChart from "./Componenets/ProfitSettlementChart.vue";
import Debtor from "./Debtor.vue";
import Ghabz from "./Ghabz.vue";
export default {
  components: {
    NetPaCard,
    ModalCustom,
    Debtor,
    AccountsChart,
    FundReserveChart,
    ProfitSettlementChart,
    AllocatedProfitsChart,
    Ghabz,
  },
  data() {
    return {
      DataAxiosTabloo: {
        ArryfildValue: "",
        Method: "Post",
        Action: "Tabloo",
        Token: this.$session.get("TokenNetPa"),
      },
      DataAxiosMarkAsRead: {
        ArryfildValue: "",
        Method: "Post",
        Action: "TablooElanat/MarkAsRead",
        Token: this.$session.get("TokenNetPa"),
      },
      DataAxiosReqNeedVam: {
        ArryfildValue: "",
        Method: "Post",
        Action: "TaeedZamen",
        Token: this.$session.get("TokenNetPa"),
      },
      DataAxiosMoavaghat: {
        ArryfildValue: "",
        Method: "Post",
        Action: "Moavaghaat",
        Token: this.$session.get("TokenNetPa"),
      },
      DataAxiosChart: {
        ArryfildValue: "",
        Method: "Post",
        Action: "ListTaahodat",
        Token: this.$session.get("TokenNetPa"),
      },
      DataAxiosFastPaymnet: {
        ArryfildValue: "",
        Method: "Post",
        Action: "Fastpayment",
        Token: this.$session.get("TokenNetPa"),
      },
      DataAxios_Variz: {
        ArryfildValue: {},
        Method: "Post",
        Action: "VarizGorohi/SetVarizGorohi",
        Token: this.$session.get("TokenNetPa"),
      },
      ListReqNeedVam: [],
      Tabloo: "loading",
      Moavaghaat: null,
      Notfheader: "",
      NotifTxt: "",
      NotifDate: "",
      Mab: "0",
      ChartLoaded: "loading",
      FastpaymentData: [],
      SumMabFastPay: 0,
      SumJarmieFastPay: 0,
      VamCoutFastPay: 0,
      TablooLength: 0,
      SumMablagh: 0,
      chartData: {},
      series: [
        {
          name: "اقساط پرداخت شده",
          data: [],
        },
        {
          name: "اقساط پرداخت نشده",
          data: [],
        },
        {
          name:
            this.$GetIsAnbohSaz() == "false"
              ? "اقساط تسویه شده"
              : "قرارداد تسویه شده",
          data: [],
        },
        {
          name: "اقساط معوقه",
          data: [],
        },
      ],
      chartOptions: {
        chart: {
          type: "bar",
          height: 350,
          stacked: true,
        },
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: "40%",
          },
        },
        stroke: {
          width: 1,
          colors: ["#fff"],
        },
        title: {
          text: "",
        },
        xaxis: {
          categories: [],
          labels: {
            formatter: function (val) {
              return val;
            },
          },
        },
        yaxis: {
          title: {
            text: undefined,
          },
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val;
            },
          },
        },
        fill: {
          opacity: 1,
        },
        legend: {
          position: "top",
          horizontalAlign: "left",
          offsetX: 40,
        },
        colors: ["#435ebe", "#f89215", "#67b221", "#E52505"],
      },
      Dargah: null,
      accessMenu1: 0,
      accessMenu2: 0,
      accessMenu4: 0,
      accessMenu3: 0,
      accessMenuAccount: 0,
      accessMenuLoan: 0,
      accessMenuTurnover: 0,
      accessMenuTabloo: 0,
      accessMenuRequestLoan: 0,
      accessMenuOnlinePaymentReport: 0,
      IsUploadAttachZamen: false,
      fileInfo: null,
      needVam: 0,
      showReadOnly: false,

      /*k.hr scroll */
      quickAccessMenuItems: [
        {
          linkCondition: this.accessMenuAccount,
          linkTo: "Accounts",
          iconClass: "fas fa-list p-1 text-warning",
          text: "حساب ها",
        },
        {
          linkCondition: this.accessMenuLoan,
          linkTo: "loan",
          iconClass: "fas fa-gift p-1 text-warning",
          text: "تسهیلات",
        },
        {
          linkCondition: this.accessMenuTurnover,
          linkTo: "Turnover",
          iconClass: "fas fa-receipt p-1 text-warning",
          text: "صورت حساب",
        },
        {
          linkCondition: this.accessMenu1,
          linkTo: "Debtor",
          iconClass: "fas fa-arrow-up p-1 text-warning",
          text: "برداشت از حساب",
        },
        {
          linkCondition: this.accessMenu2,
          linkTo: {
            name: "Deposit",
            params: { IsShowComboHesab: true, IsTashilat: false },
          },
          iconClass: "fas fa-arrow-down p-1 text-warning",
          text:
            this.$session.get("IsTaavoniEtebar") == true
              ? "افزایش اعتبار"
              : "واریز به حساب",
        },
        {
          linkCondition: this.accessMenu3,
          linkTo: {
            name: "Deposit",
            params: { IsShowComboHesab: true, IsTashilat: true },
          },
          iconClass: "fas fa-donate p-1 text-warning",
          text: "پرداخت اقساط",
        },
        {
          linkCondition: this.accessMenu4,
          linkTo: { name: "DepositGroup" },
          iconClass: "fas fa-coins p-1 text-warning",
          text: "پرداخت گروهی",
        },
        {
          linkCondition: this.accessMenuOnlinePaymentReport,
          linkTo: "OnlinePaymentReport",
          iconClass: "fas fa-file-invoice  p-1 text-warning",
          text: "گزارش پرداخت اینترنتی",
        },
        {
          linkCondition: this.accessMenuRequestLoan,
          linkTo: { name: "RequestVamNew" },
          iconClass: "fas fa-hand-holding-usd  p-1 text-warning",
          text: "درخواست وام",
        },
      ],
      scrollAmount: 0,
      isScrollable: false,
    };
  },
  methods: {
    RqNeedVam(IdNeedVam, Status, NeedVamModel) {
      if (Status == 1) {
        this.$SweetQustion(
          "توجه",
          this.taeedZemantMessage(),
          "warning",
          "اطمینان دارم",
          "منصرف شدم",
          IdNeedVam,
          this.AcceptVam,
          this.Cancel,
        );
        this.needVam = NeedVamModel;
        this.GetTblNoeZamenPolicyOnline(NeedVamModel);
      }
      if (Status == 2) {
        this.$SweetQustion(
          "توجه",
          "از رد ضمانت خود اطمینان دارید؟",
          "warning",
          "اطمینان دارم",
          "منصرف شدم",
          IdNeedVam,
          this.UnAcceptVam,
          this.Cancel,
        );
      }
    },

    taeedZemantMessage() {
      let message = "";
      if (this.$session.get("CustCode") == "643") {
        message =
          ' اینجانبان امضاءکنندگان زیر بدینوسیله با آگاهی کامل از مقررات و آیین نامه های شرکت تعاونی اعتبار کارکنان خبرگزاری جمهوری اسلامی بطورانفرادی وام نامبرده را ضمانت نموده و متعهد می شویم چنانچه بازپرداخت وام ایشان به هر دلیلی به تعویق بیفتد بدون هیچ گونه عذر و بهانه اقساط وام فوق الذکر به انضمام کارمزد و هزینه های مربوطه را پرداخت نماییم.و ذیحسابی سازمان خبرگزاری جمهوری اسلامی وکالت بلاعزل دارد مبلغ اعلام شده از سوی شرکت تعاونی اعتبار را از حقوق و سایر مطالبات اینجانبان (هر گونه که صلاح میداند) تا تسویه کامل برداشت و به حساب بدهی نامبرده نزد شرکت تعاونی اعتبار مذکور واریز نماید. ضمنا" می پذیریم که ترتیب محل امضاء به معنی حق تقدم و اولویت در ابقای تعهد نیست .چنانچه وام گیرنده بازنشسته یا به هر دلیلی از سازمان تسویه نماید و عضویت تعاونی اعتبار خود را حفظ نماید ضمانت این فرم تا پایان تسویه وام اعتبار دارد.';
      } else {
        message = "از تایید ضمانت خود اطمینان دارید؟";
      }
      return message;
    },

    changefile() {
      if (document.getElementById("Uploader").files[0].size > 1024 * 1024 * 1) {
        this.$mySweetDefaultTost(
          "عملیات ناموفق",
          "  حجم فایل مورد نظر بیشتر از 1 مگابایت است ",
          "error",
          3000,
        );
        return;
      }
      this.fileInfo = document.getElementById("Uploader").files[0];
      let DataAxiosUpload = {
        ArryfildValue: "",
        Method: "Post",
        Action: "EftetahHesab/SaveAttachmentToDb",
        Token: "",
      };
      var formdata = new FormData();
      formdata.append("IdEftetah", this.needVam.needVamId);
      formdata.append("Image", this.fileInfo);
      formdata.append("TableName", "wwwtblNeedVam");
      formdata.append("wwwtblcomboidgrp328", 181070523); //181070523 آیدی اتچ ضامنین
      DataAxiosUpload.ArryfildValue = formdata;
      this.$PostFormData(DataAxiosUpload).then((data) => {
        //Save Change state zanen
        var UpdTaeedZemanat = {
          ArryfildValue: "",
          Method: "Post",
          Action: "UpdTaeedZemanat",
          Token: this.$session.get("TokenNetPa"),
        };
        const formData = new FormData();
        formData.append("Id", this.needVam.id);
        formData.append("Status", 1);
        UpdTaeedZemanat.ArryfildValue = formData;
        this.$PostFormData(UpdTaeedZemanat).then((data) => {
          if (data.success == "SUCCESS") {
            this.$mySweetDefaultTost(
              "عملیات موفق",
              "درخواست ضمانت باموفقیت تایید شد .",
              "success",
              2000,
            );
            this.$store.state.renderComponent = false;
            this.$nextTick(() => {
              this.$store.state.renderComponent = true;
            });
            this.GetReqNeedVam();
          }
        });
      });
    },
    AcceptVam(id) {
      if (this.IsUploadAttachZamen) {
        const Time = 2000;
        this.$mySweetDefaultTost(
          "آپلود مدارک",
          "لطفا فایل مدارک ضمانت خود را  با در حالت فشارده (zip , rar) آپلود نمایید .",
          "warning",
          Time,
        );
        setTimeout(this.ShowUploaderzamen, Time);
      } else {
        //Save Change state zanen
        var UpdTaeedZemanat = {
          ArryfildValue: "",
          Method: "Post",
          Action: "UpdTaeedZemanat",
          Token: this.$session.get("TokenNetPa"),
        };
        const formData = new FormData();
        formData.append("Id", this.needVam.id);
        formData.append("Status", 1);
        UpdTaeedZemanat.ArryfildValue = formData;
        this.$PostFormData(UpdTaeedZemanat).then((data) => {
          if (data.success == "SUCCESS") {
            this.$mySweetDefaultTost(
              "عملیات موفق",
              "درخواست ضمانت باموفقیت تایید شد .",
              "success",
              2000,
            );
            this.$store.state.renderComponent = false;
            this.$nextTick(() => {
              this.$store.state.renderComponent = true;
            });
            this.GetReqNeedVam();
          }
        });
      }
    },
    UnAcceptVam(id) {
      var UpdTaeedZemanat = {
        ArryfildValue: "",
        Method: "Post",
        Action: "UpdTaeedZemanat",
        Token: this.$session.get("TokenNetPa"),
      };
      const formData = new FormData();
      formData.append("Id", id);
      formData.append("Status", 2);
      UpdTaeedZemanat.ArryfildValue = formData;
      this.$PostFormData(UpdTaeedZemanat).then((data) => {
        if (data.success == "SUCCESS") {
          this.$mySweetDefaultTost(
            "عملیات موفق",
            "درخواست ضمانت باموفقیت رد شد .",
            "success",
            2000,
          );
          this.$store.state.renderComponent = false;
          this.$nextTick(() => {
            this.$store.state.renderComponent = true;
          });
          this.GetReqNeedVam();
        }
      });
    },
    ShowUploaderzamen() {
      document.getElementById("Uploader").click();
    },
    GetTblNoeZamenPolicyOnline(ModelNeedVam) {
      this.IsUploadAttachZamen = false;
      let DataAxios = {
        ArryfildValue: "",
        Method: "Post",
        Action: "RequestVamNew/GetSettingVamAndPolicy",
        Token: this.$session.get("TokenNetPa"),
      };
      var formdata = new FormData();
      formdata.append("id", ModelNeedVam.noeId);
      DataAxios.ArryfildValue = formdata;
      this.$PostFormData(DataAxios).then((res) => {
        res.forEach((el) => {
          if (
            el.mabAz <= ModelNeedVam.mablagh &&
            el.mabTa >= ModelNeedVam.mablagh
          ) {
            this.IsUploadAttachZamen = el.isUpload;
          }
        });
      });
    },
    GetTablooElanat() {
      if (this.$session.get("CustCode") == "801") {
        const formData = new FormData();
        formData.append(
          "ShobeId",
          this.$session.get("UserInfoNetPa").wwwtblShobeId,
        );
        formData.append(
          "wwwtblTafsiliTypeId",
          this.$session.get("UserInfoNetPa").wwwtblTafsiliTypeId,
        );
        this.DataAxiosTabloo.ArryfildValue = formData;
        this.DataAxiosTabloo.Action = "Tabloo/GetTablooV2";
        this.$PostFormData(this.DataAxiosTabloo).then((data) => {
          this.Tabloo = data;
          this.TablooLength = this.Tabloo.length;
        });
      } else {
        const formData = new FormData();
        formData.append(
          "ShobeId",
          this.$session.get("UserInfoNetPa").wwwtblShobeId,
        );
        formData.append(
          "AzaNoId",
          this.$session.get("UserInfoNetPa").wwwtblAzaNoeId,
        );
        this.DataAxiosTabloo.ArryfildValue = formData;
        this.$PostFormData(this.DataAxiosTabloo).then((data) => {
          this.Tabloo = data;
          this.TablooLength = this.Tabloo.length;
        });
      }
    },
    GetReqNeedVam() {
      const formData = new FormData();
      formData.append(
        "wwwtblShobeId",
        this.$session.get("UserInfoNetPa").wwwtblShobeId,
      );
      formData.append("Today", this.$GetJalaliDate());
      formData.append(
        "wwwtblAzaId",
        this.$session.get("UserInfoNetPa").wwwtblAzaId,
      );
      this.DataAxiosReqNeedVam.ArryfildValue = formData;
      this.$PostFormData(this.DataAxiosReqNeedVam).then((data) => {
        this.ListReqNeedVam = data;
      });
    },
    GetMoavaghat() {
      const formData = new FormData();
      formData.append(
        "wwwtblAzaId",
        this.$session.get("UserInfoNetPa").wwwtblAzaId,
      );
      this.DataAxiosMoavaghat.ArryfildValue = formData;
      this.$PostFormData(this.DataAxiosMoavaghat).then((data) => {
        this.Moavaghaat = data;
        this.$store.state.renderComponent = false;
        window.dispatchEvent(new Event("resize"));
        this.$nextTick(() => {
          this.$store.state.renderComponent = true;
        });
      });
    },
    ShowFullNotif(Notif) {
      this.Notfheader = Notif.subjectTabloElanat;
      this.NotifTxt = Notif.txtMatnTabloElanat;
      this.NotifDate = Notif.zamanInsert;
      // Mark as read in database
      const itemId =
        Notif.id ||
        Notif.bnpCashDbtblTabloElanatId ||
        Notif.BnpCashDbtblTabloElanatID;
      const azaId = this.$session.get("UserInfoNetPa").wwwtblAzaId;
      if (itemId && azaId && !Notif.isItemRead) {
        const formData = new FormData();
        formData.append("TabloElanatId", itemId);
        formData.append("AzaId", azaId);
        this.DataAxiosMarkAsRead.ArryfildValue = formData;
        this.$PostFormData(this.DataAxiosMarkAsRead)
          .then((data) => {
            if (data.success === true || data.Success === true) {
              Notif.isItemRead = true;
              this.GetTablooElanat();
            }
          })
          .catch(() => {
            // Silent fail - don't show error to user
          });
      }
    },
    toggleReadFilter() {
      this.showReadOnly = !this.showReadOnly;
    },
    markAsReadWithConfirm(item) {
      this.$swal({
        title: "علامت‌گذاری به عنوان خوانده شده",
        text: "آیا مطمئن هستید که این اعلان را به عنوان خوانده شده علامت‌گذاری کنید؟",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بله، مطمئنم",
        cancelButtonText: "انصراف",
      }).then((result) => {
        if (result.isConfirmed) {
          const itemId =
            item.id ||
            item.bnpCashDbtblTabloElanatId ||
            item.BnpCashDbtblTabloElanatID;
          const azaId = this.$session.get("UserInfoNetPa").wwwtblAzaId;

          if (itemId && azaId && !item.isItemRead) {
            const formData = new FormData();
            formData.append("TabloElanatId", itemId);
            formData.append("AzaId", azaId);
            this.DataAxiosMarkAsRead.ArryfildValue = formData;

            this.$PostFormData(this.DataAxiosMarkAsRead)
              .then((data) => {
                if (data.success === true || data.Success === true) {
                  item.isItemRead = true;
                  this.GetTablooElanat();
                  this.$mySweetDefaultTost(
                    "عملیات موفق",
                    "اعلان با موفقیت به عنوان خوانده شده علامت‌گذاری شد",
                    "success",
                    2000,
                  );
                } else {
                  this.$mySweetDefaultTost(
                    "خطا",
                    "خطایی در علامت‌گذاری اعلان رخ داد",
                    "error",
                    2000,
                  );
                }
              })
              .catch(() => {
                this.$mySweetDefaultTost(
                  "خطا",
                  "خطایی در علامت‌گذاری اعلان رخ داد",
                  "error",
                  2000,
                );
              });
          }
        }
      });
    },
    isItemRead(item) {
      return item.isItemRead === true || item.isItemRead === 1;
    },
    GetDataForChart() {
      const formData = new FormData();
      formData.append(
        "wwwtblAzaId",
        this.$session.get("UserInfoNetPa").wwwtblAzaId,
      );
      formData.append("wwwtblSarfaslTypeId", 1);
      this.DataAxiosChart.ArryfildValue = formData;
      this.$PostFormData(this.DataAxiosChart).then((data) => {
        this.chartData = data;
        this.TedadKolevmaha = data.length;
        data.forEach((element) => {
          if (element.mande != 0) {
            this.chartOptions.xaxis.categories.push(element.desNoe);
            this.series[0].data.push(element.tedadAghsatPardaxtShode);
            if (element.tedadMoavaghe > 0) {
              this.series[3].data.push(element.tedadMoavaghe);
              this.series[1].data.push(
                element.tedadAghsatPardaxtNaShode - element.tedadMoavaghe,
              );
            } else {
              this.series[3].data.push(0);
              this.series[1].data.push(element.tedadAghsatPardaxtNaShode);
            }

            this.series[2].data.push(0);
          } else {
            this.chartOptions.xaxis.categories.push(element.desNoe);

            this.series[0].data.push(0);
            this.series[1].data.push(0);
            this.series[3].data.push(0);
            this.series[2].data.push(element.tedadAghsatPardaxtShode);
          }
          // this.chartOptions.plotOptions.bar.barHeight = data.length==1? 0.1:0.4
        });
        this.ChartLoaded = "true";
        this.$store.state.renderComponent = false;
        window.dispatchEvent(new Event("resize"));
        this.$nextTick(() => {
          this.$store.state.renderComponent = true;
        });
      });
    },
    GetFastpaymentData() {
      if (this.$session.get("UserInfoNetPa").wwwtblAzaId) {
        const formData = new FormData();
        formData.append(
          "wwwtblAzaId",
          this.$session.get("UserInfoNetPa").wwwtblAzaId,
        );
        formData.append("wwwtblSarfaslTypeId", 1);
        this.DataAxiosFastPaymnet.ArryfildValue = formData;
        this.$PostFormData(this.DataAxiosFastPaymnet).then((data) => {
          if (data.data) {
            for (var i = 0; i < data.data.length; i++) {
              var element = data.data[i];
              data.data[i].Active = true;
              this.SumJarmieFastPay +=
                element.wwwjarime == null ? 0 : element.wwwjarime;
            }
            this.FastpaymentData = data.data;
            this.$store.state.renderComponent = false;
            window.dispatchEvent(new Event("resize"));
            this.$nextTick(() => {
              this.$store.state.renderComponent = true;
            });
          }
        });
      } else {
        this.FastpaymentData = [];
      }
    },
    ShowAllNotifications() {},
    Pay() {
      if (this.Dargah == null) {
        if (this.$session.get("CustCode") == 801) {
          this.$swal(
            "اختلال در پرداخت با درگاه",
            "مشتری گرامی به علت  اختلال موقت درگاه ، لطفا به یکی از دو روش  پرداخت نمایید با تشکر . 1- کارت به کارت از طریق عابربانک ملی به همراه شناسه پرداخت یا شناسه واریز .  (کارت بانک ملی به شماره : 6037.9911.9952.6827)  2-  واریز به حساب از سامانه بام به همراه شناسه واریز یا شناسه پرداخت . (شماره حساب بانک ملی : 0110008020006)",
            "warning",
          );
        } else {
          this.$mySweetDefaultTost(
            "عدم انتخاب درگاه",
            "درگاهی برای سامانه تنظیم نشده است",
            "warning",
            3000,
          );
        }
      } else {
        const WwwtblVarizGorohiRiz = [];
        for (
          let index = 0;
          index < this.TotalFastPay.listFastpay.length;
          index++
        ) {
          // console.log('!!', this.TotalFastPay.listFastpay[index].wwwjarime)
          WwwtblVarizGorohiRiz.push({
            WwwtblTaahodatId: this.TotalFastPay.listFastpay[index].id,
            Mablagh: this.TotalFastPay.listFastpay[index].mablghPardakht,
            SharhRiz:
              " پرداخت سریع قسط تسهیلات " +
              this.TotalFastPay.listFastpay[index].vCode,
            WwwtblAzaId: this.$session.get("UserInfoNetPa").wwwtblAzaId,
            BnpCashDBtblTaahodatId:
              this.TotalFastPay.listFastpay[index].bnpCashDBtblTaahodatId,
            BnpCashDBtblAzaId:
              this.$session.get("UserInfoNetPa").bnpCashDBtblAzaId,
            MablaghJarime:
              this.TotalFastPay.listFastpay[index].wwwjarime == null
                ? 0
                : this.TotalFastPay.listFastpay[index].wwwjarime,
            TarixGhest:
              this.TotalFastPay.listFastpay[index].minTarGhestBedehkar,
          });
        }
        this.SumMablagh = this.TotalFastPay.SumMabFastPay;
        this.DataAxios_Variz.ArryfildValue.Mablagh = this.SumMablagh;
        this.DataAxios_Variz.ArryfildValue.CodeRahgiri = 0;
        this.DataAxios_Variz.ArryfildValue.Tarix = this.$store.state.JalaliDate;
        this.DataAxios_Variz.ArryfildValue.Sharh = "پرداخت اقساط گروهی";
        this.DataAxios_Variz.ArryfildValue.ZamanInsert =
          this.$store.state.JalaliDate;
        this.DataAxios_Variz.ArryfildValue.CustCode = Number(
          this.$session.get("UserInfoNetPa").custCode,
        );
        this.DataAxios_Variz.ArryfildValue.tblComboIdVaziatGrp312 = 5538;
        this.DataAxios_Variz.ArryfildValue.wwwtblAzaId =
          this.$session.get("UserInfoNetPa").wwwtblAzaId;
        this.DataAxios_Variz.ArryfildValue.StatusVariz = 2;
        this.DataAxios_Variz.ArryfildValue.WwwtblVarizGorohiRiz =
          WwwtblVarizGorohiRiz;
        // console.log(this.DataAxios_Variz.ArryfildValue)
        this.$PostData(this.DataAxios_Variz).then((result) => {
          this.$Payment(
            JSON.stringify(this.Dargah),
            JSON.stringify(this.SumMablagh),
            this.$session.get("UserInfoNetPa").ozvName +
              " " +
              this.$session.get("UserInfoNetPa").ozvFamily,
            this.$session.get("UserInfoNetPa").email,
            this.$session.get("UserInfoNetPa").mobile,
            WwwtblVarizGorohiRiz[0].WwwtblTaahodatId,
            "",
            this.TotalFastPay.listFastpay[0].vCode,
            "سبد اقساط",
            JSON.stringify(this.$session.get("UserInfoNetPa").wwwtblAzaId),
            this.$session.get("UserInfoNetPa").custCode,
            JSON.stringify(this.$session.get("UserInfoNetPa").wwwtblShobeId),
            result.idRepoMaster,
            this.$session.get("UserInfoNetPa").codeMeli,
            this.$session.get("UserInfoNetPa").ozvName +
              " " +
              this.$session.get("UserInfoNetPa").ozvFamily,
            this.$session.get("UserInfoNetPa").mobile,
            this.$session.get("UserInfoNetPa").codeMeli,
          );
        });
      }
    },
    OpenUploader(Type) {
      // Type 1= ExcelFile, Type 2=JsonFile
      if (Type == 1) {
        document.getElementById("FileHokm").click();
      }
      if (Type == 2) {
        document.getElementById("FileZemanat").click();
      }
      if (Type == 3) {
        document.getElementById("FileGhrardad").click();
      }
    },
    openGhabz(index) {
      this.$router.push({ name: "BillPayment", params: { indexMenu: index } });
    },
    /*k.hr quick access menu scroll methods*/
    calcMarginAndWidth() {
      /*این تابع اندازه ی هر ستون با کلاس 
        col-1
        را بدست می آورد تا دقیقا به اندازه‌ی یک ستون اسکرول را انجام بدهد */
      const container = this.$refs.scrollContainer;
      if (!container) return;

      const firstColumn = container.querySelector(".col-1");
      const rect = firstColumn.getBoundingClientRect();
      this.columnWidth = rect.width;
      const computedStyle = window.getComputedStyle(firstColumn);
      const marginLeft = parseFloat(computedStyle.marginLeft) || 0;
      const marginRight = parseFloat(computedStyle.marginRight) || 0;
      this.columnMargin = marginLeft + marginRight;
      this.scrollAmount = this.columnWidth + this.columnMargin;
    },

    animateScroll(container, scrollAmount, duration = 500) {
      const start = container.scrollLeft;
      const target = start + scrollAmount;
      let startTime = null;

      // Easing function (smooth acceleration/deceleration)
      const easeInOutQuad = (t) => (t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t);

      const animate = (currentTime) => {
        if (!startTime) startTime = currentTime;
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);
        const easedProgress = easeInOutQuad(progress);

        container.scrollLeft = start + (target - start) * easedProgress;

        if (progress < 1) {
          requestAnimationFrame(animate);
        }
      };

      requestAnimationFrame(animate);
    },

    scrollLeft() {
      if (this.$refs.scrollContainer) {
        this.calcMarginAndWidth();
        this.animateScroll(this.$refs.scrollContainer, -this.scrollAmount, 500);
      }
    },
    scrollRight() {
      this.calcMarginAndWidth();
      if (this.$refs.scrollContainer) {
        this.animateScroll(this.$refs.scrollContainer, this.scrollAmount, 500);
      }
    },
    updateScrollability() {
      const container = this.$refs.scrollContainer;
      if (container) {
        this.isScrollable = container.scrollWidth > container.clientWidth;
      }
    },
    // Method to handle window resize
    handleResize() {
      this.updateScrollability();
    },
  },
  mounted() {
    this.accessMenuAccount = this.$session
      .get("AccessMenu")
      .filter((x) => x.id == 5)[0].isMenu;
    this.quickAccessMenuItems[0].linkCondition = this.accessMenuAccount;

    this.accessMenuLoan = this.$session
      .get("AccessMenu")
      .filter((x) => x.id == 9)[0].isMenu;
    this.quickAccessMenuItems[1].linkCondition = this.accessMenuLoan;

    this.accessMenuTurnover = this.$session
      .get("AccessMenu")
      .filter((x) => x.id == 6)[0].isMenu;
    this.quickAccessMenuItems[2].linkCondition = this.accessMenuTurnover;

    this.accessMenu1 = this.$session
      .get("AccessMenu")
      .filter((x) => x.id == 13)[0].isMenu;
    this.quickAccessMenuItems[3].linkCondition = this.accessMenu1;

    this.accessMenu2 = this.$session
      .get("AccessMenu")
      .filter((x) => x.id == 7)[0].isMenu;
    this.quickAccessMenuItems[4].linkCondition = this.accessMenu2;

    this.accessMenu3 = this.$session
      .get("AccessMenu")
      .filter((x) => x.id == 11)[0].isMenu;
    this.quickAccessMenuItems[5].linkCondition = this.accessMenu3;

    this.accessMenu4 = this.$session
      .get("AccessMenu")
      .filter((x) => x.id == 20)[0].isMenu;
    this.quickAccessMenuItems[6].linkCondition = this.accessMenu4;

    this.accessMenuOnlinePaymentReport = this.$session
      .get("AccessMenu")
      .filter((x) => x.id == 19)[0].isMenu;
    this.quickAccessMenuItems[7].linkCondition =
      this.accessMenuOnlinePaymentReport;

    this.accessMenuRequestLoan = this.$session
      .get("AccessMenu")
      .filter((x) => x.id == 33)[0].isMenu;
    this.quickAccessMenuItems[8].linkCondition = this.accessMenuRequestLoan;

    this.accessMenuTabloo = this.$session
      .get("AccessMenu")
      .filter((x) => x.id == 82)[0].isMenu;

    //   this.accessMenu1=true
    //   this.accessMenu2=true
    //   this.accessMenu3=true
    //   this.accessMenu4=true
    //خواندن اطلاعات درگاه از دیتابیس
    this.$Gateway().then((data) => {
      if (data.status == "Ok") {
        data.data.forEach((element) => {
          if (
            (element.gatewayCode != null || element.gatewayCode != "") &&
            element.isDefault == true
          ) {
            this.Dargah = element.id;
          }
        });
      } else {
        this.$mySweetDefaultTost("عدم وجود اطلاعات", data.msg, "warning", 2000);
      }
    });

    this.GetFastpaymentData();
    this.GetDataForChart();

    /*k.hr*/
    this.updateScrollability();
    window.addEventListener("resize", this.handleResize);
  },
  computed: {
    TotalFastPay() {
      var shomarande = 0;
      var SumMabFastPay = 0;
      var VamCoutFastPay = 0;
      var SumJarmieFastPay = 0;
      var listFastpay = [];
      for (let index = 0; index < this.FastpaymentData.length; index++) {
        const element = this.FastpaymentData[index];
        if (element.Active) {
          shomarande++;
          SumMabFastPay += element.mablghPardakht;
          SumJarmieFastPay += element.wwwjarime == null ? 0 : element.wwwjarime;
          listFastpay.push(element);
        }
      }
      VamCoutFastPay = shomarande;
      return {
        VamCoutFastPay: VamCoutFastPay,
        SumJarmieFastPay: SumJarmieFastPay,
        SumMabFastPay: SumMabFastPay,
        listFastpay: listFastpay,
      };
    },
    filteredTabloo() {
      if (this.Tabloo === "loading" || !Array.isArray(this.Tabloo)) {
        return this.Tabloo;
      }

      if (this.showReadOnly) {
        // نمایش فقط آیتم‌های خوانده شده
        return this.Tabloo.filter((item) => {
          return item.isItemRead === true || item.isItemRead === 1;
        });
      } else {
        // نمایش فقط آیتم‌های خوانده نشده
        return this.Tabloo.filter((item) => {
          return !(item.isItemRead === true || item.isItemRead === 1);
        });
      }
    },
    filteredTablooLength() {
      if (this.Tabloo === "loading" || !Array.isArray(this.Tabloo)) {
        return 0;
      }
      return this.filteredTabloo.length;
    },
  },
  updated() {
    this.$PutCommatoInput();
    this.accessMenu1 = this.$session
      .get("AccessMenu")
      .filter((x) => x.id == 13)[0].isMenu;
    this.accessMenu2 = this.$session
      .get("AccessMenu")
      .filter((x) => x.id == 7)[0].isMenu;
    this.accessMenu3 = this.$session
      .get("AccessMenu")
      .filter((x) => x.id == 11)[0].isMenu;
    this.accessMenuRequestLoan = this.$session
      .get("AccessMenu")
      .filter((x) => x.id == 33)[0].isMenu;

    this.accessMenuOnlinePaymentReport = this.$session
      .get("AccessMenu")
      .filter((x) => x.id == 19)[0].isMenu;
  },
  created() {
    this.GetReqNeedVam();
    this.GetTablooElanat();
    this.GetMoavaghat();
    const vw = Math.max(
      document.documentElement.clientWidth || 0,
      window.innerWidth || 0,
    );
    if (vw < 1080) {
      this.chartOptions.plotOptions.bar.horizontal = false;
      this.chartOptions.chart.height = 550;
      this.chartOptions.chart.width = 50;
    }
  },
};
</script>

<style scoped>
.max-h-15 {
  max-height: 8vh !important;
  overflow-y: hidden;
}
.textVerticalCenter {
  position: absolute;
  top: 30%;
  white-space: nowrap;
  right: 15%;
}
.bg-dark {
  background: #2a3f54 !important;
}
.border-danger {
  border-right: 2px solid #d10000 !important;
}
.badge-success {
  background: #67b221 !important;
  border-radius: 15px;
}
.btn-outline-dark:hover {
  background: none;
  color: rgb(41, 41, 41) !important;
}
.scroll_btn {
  background: #fff;
  cursor: pointer;
}

.scrl-r:active {
  box-shadow: -15px 1px 12px -7px #e8e8e8;
  border: none;
}

.scrl-l:active {
  box-shadow: 15px 1px 12px -7px #e8e8e8;
  border: none;
}
/*k.hr*/

.quickAccessItem {
  transition: transform 0.3s ease-out, opacity 0.3s ease-out;
  display: inline-block;
  cursor: pointer;
}
.quickAccessItem p {
  font-size: clamp(14px, 3vw, 16px); /* Adjust text size similarly */
  transition: color 0.3s ease-out;
  margin-bottom: 0;
}

.quickAccessItem i {
  font-size: clamp(36px, 5vw, 50px); /* min-size, preferred-size, max-size */
  transition: transform 0.3s ease-out, opacity 0.3s ease-out,
    color 0.3s ease-out;
  display: block;
  margin-bottom: 10px;
}

.quickAccessItem:hover {
  transform: scale(1.01); /* Slightly larger */
  opacity: 0.9; /* Slightly less opaque for a subtle darkening effect */
}

.quickAccessItem:hover i {
  transform: translateY(-8px) scale(1.1); /* Keep icon lift, add slight scale */
}
</style>
<style>
tspan {
  font-family: "";
}

.animate__animated.animate__swing {
  --animate-duration: 1s;
}

.Uploader {
  width: 100%;
  border: 2px dashed #0c6ec9 !important;
  border-radius: 8px;
}
.Uploader:hover .fa-file-import {
  color: #0c6ec9 !important;
  transition: 0.3s;
}
@media (min-width: 1500px) {
  .col-xxl-7 {
    flex: 0 0 calc(100% / 12 * 7);
    max-width: calc(100% / 12 * 7);
  }
}
</style>
